import * as React from "react";
import {
  HoverCard,
  IHoverCard,
  IPlainCardProps,
  HoverCardType,
  ThemeProvider,
  Text,
  mergeStyles,
  Link,
} from "@fluentui/react";
import { HorizontalStack } from "../../Stack";
import { colorPallete } from "../../../assets/color";
import { UserModel } from "../../../models";
import { useTranslation } from "react-i18next";
import useModal from "../../../hooks/useModal";
import { EmailTemplateModal } from "../../modals/EmailTemplateModal";
import SendIcon from "../../../assets/Icons/svg/sendIcon";
import ReceivedIcon from "../../../assets/Icons/svg/receivedIcon";

interface HoverCardProps {
  notes: string | undefined;
  fileType: string | undefined;
  sharedBy: UserModel | undefined;
  sharedTo: UserModel[] | undefined;
  projectName: string | undefined;
  viewType?: string;
  receivedList?: UserModel[] | undefined;
  subject?: string | undefined;
  metadataFileType?: string | undefined;
  children?: React.ReactNode;
  showHoverEffect?: boolean;
}


const styles = {
  Others: {
    fontSize: "12px",
    borderRadius: "8px",
    minWidth: "1px",
    maxWidth: "fit-content",
    color: "rgb(6 42 108)",
    cursor: "pointer",
    fontWeight: 500,
  },
  sentToList: {
    marginTop: "1%",
    display: "inline-block",
    height: "100%",
    width: "90%",
  },
  firstEmailInCard: {
    textDecorationLine: "underline",
    fontWeight: 500,
    color: "#18468F",
    fontSize: "12px",
    lineHeight: "18px",
    fontFamily: "Poppins",
  },
  card: {
    width: "328px",
    height: "max-content",
    // padding: "10px",
    // bottom: "70%",
    borderRadius: "8px",
  },
  sharedBy: {
    width: "324px",
    height: "18px",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 500,
    fontFamily: "Poppins",
  },
  sharedToStack: {
    gap: "2%",
    justifyContent: "flex-start",
    width: "98%",
    paddingTop: "2px",
    alignItems: "center",
  },
  sharedTo: {
    alignSelf: "flex-end",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 500,
    fontFamily: "Poppins",
    color: colorPallete.black,
    width: "fit-content",
  },

  sharedToList: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 500,
    fontFamily: "Poppins",
    color: colorPallete.black,
    width: "80%",
  },
};
const notesStyles = mergeStyles({
  fontWeight: 400,
  fontSize: "12px",
  fontFamily: "Poppins",
  color: colorPallete.grey,
  lineHeight: "18px",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const EmailNotesHoverCard: React.FunctionComponent<HoverCardProps> = (
  props
) => {
  const hoverCard = React.useRef<IHoverCard>(null);
  const { t } = useTranslation();
  const { isModalOpen, showModal, hideModal } = useModal();
  const [isHoverCardVisible, setIsHoverCardVisible] = React.useState(false);
  const [isIconHovered, setIsIconHovered] = React.useState(false);

  const showHoverEffect = props.showHoverEffect !== undefined 
    ? props.showHoverEffect 
    : (props.viewType !== "list");
  const onRenderPlainCard = (): JSX.Element => {
    return (
      <div style={styles.card}>
        <HorizontalStack
          style={{
            gap: "2px",
            paddingBottom: "8px",
            width: "304px",
          }}
          title={props.subject}
        >
          <Text
            style={{
              width: "90%",
              fontSize: "12px",
              lineHeight: "18px",
              fontFamily: "Poppins",
              fontWeight: 600,
              color: "#323232",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: 1,
            }}
          >
            {t("Subject")}: {props.subject}
          </Text>
        </HorizontalStack>
        <HorizontalStack
          style={{
            width: "86%",
            height: "max-content",
            backgroundColor: "",
            gap: "8px",
            position: "relative",
          }}
        >
          <Text className={notesStyles} style={{ WebkitLineClamp: 2 }}>
            {props.notes!}
          </Text>
          <Link
            style={{
              fontSize: "12px",
              fontFamily: "Poppins",
              lineHeight: "18px",
              fontWeight: 400,
              height: "18px",
              zIndex: 5,
              position: "absolute",
              right: 0,
              bottom: 0,
              backgroundColor: "white",
              paddingLeft: "5px",
            }}
            onClick={showModal}
          >
            {t("read_more")}
          </Link>
        </HorizontalStack>
      </div>
    );
  };

  const plainCardProps: IPlainCardProps = {
    onRenderPlainCard: onRenderPlainCard,
  };

  return (
    <>
      {props.fileType === "received" && (
          <div style={{ borderRadius: "5px"}}>
          <HoverCard
            type={HoverCardType.plain}
            plainCardProps={plainCardProps}
            componentRef={hoverCard}
            instantOpenOnClick={false}
            cardOpenDelay={200}
            cardDismissDelay={300}
            onCardVisible={() => setIsHoverCardVisible(true)}
            onCardHide={() => setIsHoverCardVisible(false)}
            style={{
              borderRadius: "8px",
              width: "300px",
              padding: "12px",
              gap: "5px",
            }}
          >
            <div
              style={{
                position: "relative",
                padding:
                  (showHoverEffect)
                    ? "8px"
                    : "0px",
                marginRight: (showHoverEffect && props.viewType !== "list")
                ? "0px"
                : (props.viewType === "list" ? "" : "8px"),
                borderRadius: "4px",
                transition: "all 0.2s ease-in-out",
                cursor: "pointer",
                display: "inline-block",
                height: (props.viewType !== "list") ? "40px" : "auto",
                backgroundColor:
                  ((isHoverCardVisible || isIconHovered) && showHoverEffect)
                    ? "rgba(255, 255, 255, 0.5)"
                    : (props.viewType === "list" ? "" : "transparent"),
                border: ((isHoverCardVisible || isIconHovered) && showHoverEffect)
                  ? "1px solid #FFF"
                  : "1px solid transparent",
                boxShadow: ((isHoverCardVisible || isIconHovered) && showHoverEffect)
                  ? "0 4px 4px 0 rgba(0, 0, 0, 0.08)"
                  : "none",
              }}
              onMouseEnter={showHoverEffect ? () => setIsIconHovered(true) : undefined}
              onMouseLeave={showHoverEffect ? () => setIsIconHovered(false) : undefined}
            >
              {props.children ? (
                <HorizontalStack style={{ gap: "8px", alignItems: "center" }}>
                  {props.children}
                  <ReceivedIcon />
                </HorizontalStack>
              ) : (
                <ReceivedIcon />
              )}
            </div>
          </HoverCard>
          </div>
      )}

      {props.fileType === "sent" && (
        <div style={{ borderRadius: "5px", backgroundColor: "Transparent", position: "relative" }}>
            <HoverCard
              type={HoverCardType.plain}
              plainCardProps={plainCardProps}
              componentRef={hoverCard}
              instantOpenOnClick={false}
              cardOpenDelay={200}
              cardDismissDelay={300}
              onCardVisible={() => setIsHoverCardVisible(true)}
              onCardHide={() => setIsHoverCardVisible(false)}
              style={{
                borderRadius: "8px",
                width: "300px",
                padding: "12px",
                gap: "5px",
                marginRight: "8px",
              }}
            >
              <div
                style={{
                  padding:
                  (showHoverEffect)
                    ? "8px"
                    : "0px",
                  marginRight: (showHoverEffect && props.viewType !== "list")
                  ? "0px"
                  : (props.viewType === "list" ? "" : "8px"),
                  borderRadius: "4px",
                  transition: "all 0.2s ease-in-out",
                  cursor: "pointer",
                  display: "inline-block",
                  height: (props.viewType !== "list") ? "40px" : "auto",
                  backgroundColor:
                    ((isHoverCardVisible || isIconHovered) && showHoverEffect)
                      ? "rgba(255, 255, 255, 0.5)"
                      : (props.viewType === "list" ? "" : "transparent"),
                  border: ((isHoverCardVisible || isIconHovered) && showHoverEffect)
                    ? "1px solid #FFF"
                    : "1px solid transparent",
                  boxShadow: ((isHoverCardVisible || isIconHovered) && showHoverEffect)
                    ? "0 4px 4px 0 rgba(0, 0, 0, 0.08)"
                    : "none",
                }}
                onMouseEnter={showHoverEffect ? () => setIsIconHovered(true) : undefined}
                onMouseLeave={showHoverEffect ? () => setIsIconHovered(false) : undefined}
              >
                {props.children ? (
                  <HorizontalStack style={{ gap: "8px", alignItems: "center" }}>
                    {props.children}
                    <SendIcon />
                  </HorizontalStack>
                ) : (
                  <SendIcon />
                )}
              </div>
            </HoverCard>
        </div>
      )}
      {props.metadataFileType === "pdf" && props.fileType !== "received" || props.fileType !== "sent" && (
          <div style={{ borderRadius: "5px", backgroundColor: "Transparent !important" }}>
            <HoverCard
              type={HoverCardType.plain}
              plainCardProps={plainCardProps}
              componentRef={hoverCard}
              style={{
                borderRadius: "8px",
                width: "300px",
                padding: "12px",
                gap: "5px",
              }}
            >
              <div
                  style={{
                    backgroundColor:
                      props.viewType === "list" ? "" : "rgba(223, 230, 239, 0.55)",
                  }}
                >
                {props.children}
              </div>
            </HoverCard>
          </div>
      )}

      <EmailTemplateModal
        isModalOpen={isModalOpen}
        showModal={showModal}
        hideModal={hideModal}
        sharedBy={props.sharedBy}
        sharedTo={props.sharedTo}
        projectName={props.projectName}
        emailNotes={props.notes}
        fileType={props.fileType}
        receivedList={props.receivedList}
        subject={props.subject}
      />
    </>
  );
};
